import React, { useState, useEffect } from "react";
import { colors } from "../../../../../../themes/Colors";
import { BaseButtons, TextInputField } from "../../../../../common-components";
import { LandingCard } from "../../../../../web-site/components";

const ManageCardsPopUp = ({
  display,
  onCloseClick,
  width,
  onImageLink,
  onColorChange,
  imagelink,
  onTagLine,
  onCardChange,
  onInfoLink,
  onSubTitle,
  onPara1,
  onPara2,
  subTitle,
  tagLine,
  cardTitle,
  para1,
  para2,
  selectedCard,
  setSelectedCard,
  displayedIndex,
  setImageLink,
  onSaveClick,
}) => {
  const backGroundColorSelecto = () => {
    if (displayedIndex === 0) {
      return colors.primaryBlue;
    } else if (displayedIndex === 1) {
      return colors.primaryOrange;
    } else if (displayedIndex === 2) {
      return colors.primaryPink;
    } else if (displayedIndex === 3) {
      return colors.primaryPurple;
    } else if (displayedIndex === 4) {
      return colors.secondaryPink;
    } else if (displayedIndex === 5) {
      return colors.secondaryOrange;
    }
  };

  return (
    <div
      style={{
        height: display ? "100%" : 0,
        width: "100%",
        position: "absolute",
        top: 0,
        overflow: "hidden",
        display: "flex",
        flexDirection: "row",
        backgroundColor: colors.secondaryGrey,
        transition: "all 0.5s",
        opacity: display ? 1 : 0,
      }}
    >
      <div style={{ position: "absolute", left: 20, top: 20 }}>
        <BaseButtons
          label={"CLOSE"}
          backgroundColor={colors.secondaryOrange}
          borderRadius={8}
          onClick={onCloseClick}
          width={100}
        />
      </div>
      <div
        style={{
          flex: 0.7,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: backGroundColorSelecto(),
        }}
      >
        <LandingCard
          editorDisplay={true}
          backgroundColorButton={backGroundColorSelecto(0)}
          width={width}
          display={true}
          info={para1 ? para1 : selectedCard ? selectedCard.paragraph1 : null}
          info2={para2 ? para2 : selectedCard ? selectedCard.paragraph2 : null}
          cardImage={
            imagelink ? imagelink : selectedCard ? selectedCard.imageLink : null
          }
          imageHeight={width > 599 ? 300 : 200}
          cardtitle={
            cardTitle ? cardTitle : selectedCard ? selectedCard.cardTitle : null
          }
          subTitle={
            subTitle ? subTitle : selectedCard ? selectedCard.subTitle : null
          }
          shortText={
            tagLine ? tagLine : selectedCard ? selectedCard.tagLine : null
          }
        />
      </div>
      <div
        style={{
          flex: 0.3,
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
        }}
      >
        <div
          style={{ width: "100%", overflowY: "scroll", overflowX: "hidden" }}
        >
          <div
            style={{
              width: "100%",
              textAlign: "center",
              height: 50,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              fontWeight: "bold",
              fontSize: 18,
            }}
          >
            MANAGE CARD INFORMATION
          </div>
          <TextInputField
            labelTitle={"IMAGE LINK"}
            mini={true}
            onChange={onImageLink}
            value={imagelink}
          />
          <TextInputField
            labelTitle={"CARD TITLE"}
            mini={true}
            value={cardTitle}
            onChange={onCardChange}
          />
          <TextInputField
            labelTitle={"TAG LINE"}
            mini={true}
            value={tagLine}
            onChange={onTagLine}
          />
          <TextInputField
            labelTitle={"SUB TITLE"}
            mini={true}
            value={subTitle}
            onChange={onSubTitle}
          />
          <TextInputField
            labelTitle={"PARAGRAPH 1"}
            mini={true}
            value={para1}
            onChange={onPara1}
          />
          <TextInputField
            labelTitle={"PARAGRAPH 2"}
            mini={true}
            value={para2}
            onChange={onPara2}
          />

          <TextInputField
            labelTitle={"INFO BUTTON LINK"}
            mini={true}
            onChange={onInfoLink}
          />
          <TextInputField
            labelTitle={"NEW COLOR ( HEX VALUE )"}
            mini={true}
            placeholder={"e.g. #FAA919"}
            onChange={onColorChange}
          />
          <div style={{ display: "flex", marginTop: 10 }}>
            <BaseButtons
              backgroundColor={colors.orangeDark}
              label={"DELETE"}
              width={"50%"}
            />
            <BaseButtons
              backgroundColor={colors.secondaryDarkBlue}
              label={"UNDO CHANGES"}
              width={"50%"}
            />
          </div>
          <BaseButtons
            backgroundColor={colors.secondaryDarkBlue}
            label={"SAVE CHANGES"}
            width={"100%"}
            onClick={onSaveClick}
          />
          {/* <div style={{ height: 5 }} /> */}
        </div>
      </div>
    </div>
  );
};

export default ManageCardsPopUp;
